import React, { useState, useRef, useEffect } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
    const [fadeOut, setFadeOut] = useState(false);
    const [progress, setProgress] = useState(0);
    const videoRef = useRef(null);
    const fallbackTimerRef = useRef(null);

    // Fallback: dismiss after 8 seconds if video doesn't end
    useEffect(() => {
        fallbackTimerRef.current = setTimeout(() => {
            handleDismiss();
        }, 8000);

        return () => {
            if (fallbackTimerRef.current) clearTimeout(fallbackTimerRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Track video progress for the progress bar
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const onTimeUpdate = () => {
            if (video.duration) {
                setProgress((video.currentTime / video.duration) * 100);
            }
        };

        video.addEventListener('timeupdate', onTimeUpdate);
        return () => video.removeEventListener('timeupdate', onTimeUpdate);
    }, []);

    const handleDismiss = () => {
        if (fadeOut) return; // prevent double-call
        setFadeOut(true);
        if (fallbackTimerRef.current) clearTimeout(fallbackTimerRef.current);
        setTimeout(() => {
            onComplete();
        }, 800); // wait for fade animation
    };

    const handleVideoEnd = () => {
        handleDismiss();
    };

    const handleSkip = () => {
        handleDismiss();
    };

    return (
        <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
            <div className="splash-video-wrapper">
                <video
                    ref={videoRef}
                    className="splash-video"
                    src="/EFat20.mp4"
                    autoPlay
                    muted
                    playsInline
                    onEnded={handleVideoEnd}
                />
                <div
                    className="splash-progress-bar"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default SplashScreen;
